import type { ElementTweenFunction } from '../types';
import { gsap } from 'gsap';

/**
 * Premade tween: Fades out the target element to opacity 0.
 * Can be added to an elementsTimeline at a specific position.
 * @param target - The element to animate.
 * @param options - Customization options.
 * @param elementsTimeline - Optional timeline to add this tween to.
 * @param position - Optional insertion point in the elementsTimeline.
 * @returns A GSAP tween instance or void if added to a timeline.
 */
export const fadeOut: ElementTweenFunction = ({
    target,
    options,
    elementsTimeline,
    position,
    direction,
    duration: propDuration // Allow duration override via props
}) => {
    if (direction === "back") return { tween: undefined, position: "0" }

    const duration = propDuration ?? options?.duration ?? 1.5; // Use propDuration > options.duration > default
    const ease = options?.ease ?? 'power1.in'; // Changed default ease for fade out
    const tween = gsap.to(target, {
        autoAlpha: 0, duration, ease, ...options // Spread remaining options
    });

    if (elementsTimeline) {
        elementsTimeline.add(tween, position);
        return { tween: undefined, position: "<60%" } // Assuming similar positioning logic as fadeIn
    }

    return { tween, position: "<" }; // Return the tween if not added to a timeline
};
